import { Skeleton, Table } from '@chakra-ui/react'

interface SkeletonTableProps {
  /**
   * Optional unique identifier for the skeleton table.
   * This is necessary to specify if you include SkeletonTable in a list
   * to ensure that each skeleton row has a unique key.
   * @default undefined
   * @example
   * <SkeletonTable id="my-skeleton-table" skeletonWidths={[100, 200]} />
   */
  id?: string
  skeletonWidths: number[]
  rows?: number
}

const SkeletonTable = ({
  id = 'skeleton',
  skeletonWidths,
  rows = 10,
}: SkeletonTableProps) => {
  return (
    <>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <Table.Row
          // biome-ignore lint/suspicious/noArrayIndexKey: only use of skeletons so it's ok to use an index key here
          key={`${id}-${rowIndex}`}
        >
          {skeletonWidths.map((width, columnIndex) => (
            <Table.Cell
              // biome-ignore lint/suspicious/noArrayIndexKey: only use of skeletons so it's ok to use an index key here
              key={`${id}-cell-${rowIndex}-${columnIndex}`}
            >
              <Skeleton w={`${width}px`} h="20px" />
            </Table.Cell>
          ))}
        </Table.Row>
      ))}
    </>
  )
}

export default SkeletonTable
